export enum ThirdStepSectionKey {
  ADDITIONAL_INFORMATION_SECTION = 'ADDITIONAL_INFORMATION_SECTION',
  INSURER_DATA_SECTION = 'INSURER_DATA_SECTION',
  CESSION_SECTION = 'CESSION_SECTION',
  INSTALLMENT_SECTION = 'INSTALLMENT_SECTION',
  SUMMARY_SECTION = 'SUMMARY_SECTION',
  METHOD_PAYMENT_SECTION = 'METHOD_PAYMENT_SECTION'
}
